// extracted by mini-css-extract-plugin
export default {"button":"AuthNavigate_button__-fGJU"};